import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function SunIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V4C12.75 4.41421 12.4142 4.75 12 4.75C11.5858 4.75 11.25 4.41421 11.25 4V3C11.25 2.58579 11.5858 2.25 12 2.25Z"
        fill="currentColor"
      />
      <path
        d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z"
        fill="currentColor"
      />
      <path
        d="M12.75 20C12.75 19.5858 12.4142 19.25 12 19.25C11.5858 19.25 11.25 19.5858 11.25 20V21C11.25 21.4142 11.5858 21.75 12 21.75C12.4142 21.75 12.75 21.4142 12.75 21V20Z"
        fill="currentColor"
      />
      <path
        d="M20.6494 7.16419C20.8565 7.52291 20.7336 7.9816 20.3749 8.18871L19.5089 8.68871C19.1502 8.89582 18.6915 8.77291 18.4844 8.41419C18.2773 8.05547 18.4002 7.59678 18.7589 7.38967L19.6249 6.88967C19.9836 6.68256 20.4423 6.80547 20.6494 7.16419Z"
        fill="currentColor"
      />
      <path
        d="M3.62512 8.18871C3.2664 7.9816 3.1435 7.52291 3.3506 7.16419C3.55771 6.80547 4.0164 6.68256 4.37512 6.88967L5.24115 7.38967C5.59987 7.59678 5.72277 8.05547 5.51567 8.41419C5.30856 8.77291 4.84987 8.89582 4.49115 8.68871L3.62512 8.18871Z"
        fill="currentColor"
      />
      <path
        d="M3.3506 16.9747C3.1435 16.616 3.2664 16.1573 3.62512 15.9502L4.49115 15.4502C4.84987 15.2431 5.30856 15.366 5.51567 15.7247C5.72277 16.0834 5.59987 16.5421 5.24115 16.7492L4.37512 17.2492C4.0164 17.4563 3.55771 17.3334 3.3506 16.9747Z"
        fill="currentColor"
      />
      <path
        d="M20.3749 15.9502C20.7336 16.1573 20.8565 16.616 20.6494 16.9747C20.4423 17.3334 19.9836 17.4563 19.6249 17.2492L18.7589 16.7492C18.4002 16.5421 18.2773 16.0834 18.4844 15.7247C18.6915 15.366 19.1502 15.2431 19.5089 15.4502L20.3749 15.9502Z"
        fill="currentColor"
      />
    </svg>
  )
}
